/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
            redirectButtonText: string,
            redirectUrl: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
};

export const firstResponderMessagesEN: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    limitExceededError: 'Verification Limit <br><br> Exceeded',
    step: {
        docUpload: {
            title: 'We need more <br><br> information',
            subtitle: 'Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner.',
            docDisplay: 'Upload your government-issued document that shows:',
            uploadDocFullName: 'Your full name',
            uploadDocOrg: 'Your organization',
            uploadDocAffiliation: 'Your current affiliation with that organization',
            acceptableUploadExamples: 'Acceptable examples include:',
            uploadDocIdCard: 'ID Card',
            uploadDocPayStub: 'Pay stub dated within last 60 days',
            uploadDocOfficialDoc: 'An official letter',
            fileInstructions: 'Drag &amp; drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            uploadDocAcceptableFormats: 'File must be .jpg .png .pdf .gif or .bmp',
            addFile: 'Add file',
            submitButtonLabel: 'Submit',
            cancelButtonLabel: 'Cancel',
        },
        pending: {
            title: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.',
            subtitle2: 'This process may take up to 20 minutes.',
            subtitle3: 'You will be contacted via email.',
        },
        success: {
            title: "Success! <br><br>You've been verified",
            subtitle: 'Here is your personal promo code. <br>It is unique to you and can only be used once.',
            copyCouponCode: 'Copy promo code',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to {companyName} customer service.
            `,
            redirectButtonText: 'Continue',
            redirectUrl: 'https://www.kipling-usa.com/new-products-collections/',
        },
    },
};
